// extracted by mini-css-extract-plugin
export var HeroVideo = "index-module--HeroVideo--wa-Wy";
export var HeroVideoText = "index-module--HeroVideoText--NwJyW";